import "./index.css";

import { FirebaseNotificationPrompt } from "@components/Blocks/FirebaseNotificationPrompt/FirebaseNotificationPrompt";
import { GTM_ID } from "@components/Elements/GAData/GADataConstants";
import { GTMProvider } from "@elgorditosalsero/react-gtm-hook";
import { LightboxProvider } from "@sphtech/idpf-lightbox-react";
import { RenderContext } from "@sphtech/web2-core/ssr";
import NeuronProvider from "@web2/providers/NeuronProvider";
import NewRelic from "@web2/providers/NewRelic";
import { ReactElement, useContext } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Outlet, ScrollRestoration } from "react-router";

import styles from "./App.module.css";
import { IS_PLAYWRIGHT_TEST } from "./helper/getEnvVariables";
import useSessionRefresh from "./hooks/useSessionRefresh";
import HeadScriptProvider from "./providers/HeadScriptProvider";

function SessionRefreshHandler() {
  useSessionRefresh();
  return null;
}

export default function App(): ReactElement {
  const renderContext = useContext(RenderContext);
  return (
    <>
      {IS_PLAYWRIGHT_TEST !== "true" && (
        <>
          <HeadScriptProvider />
          <FirebaseNotificationPrompt />
        </>
      )}
      <NeuronProvider>
        <LightboxProvider>
          <SessionRefreshHandler />
          <ScrollRestoration />
          <HelmetProvider context={renderContext.helmet}>
            <GTMProvider state={{ id: GTM_ID }}>
              <NewRelic />
              {IS_PLAYWRIGHT_TEST === "true" ? (
                <></>
              ) : (
                <>
                  <div id="MyPageOverlay" className={styles.overlayWhite}></div>
                  <div id="postitial_holder"></div>
                  <div id="innity-flexframe-xxl-placeholder"></div>
                </>
              )}
              <Outlet />
            </GTMProvider>
          </HelmetProvider>
        </LightboxProvider>
      </NeuronProvider>
    </>
  );
}

// Custom App for OAuth callback page
export function OAuthCustomApp(): ReactElement {
  // Add any custom providers or wrappers needed for the OAuth callback page here
  return <></>;
}
